var _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVideoDisabled = function SvgVideoDisabled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M50,99.5h0A49.5,49.5,0,0,1,.5,50h0A49.5,49.5,0,0,1,50,.5h0A49.5,49.5,0,0,1,99.5,50h0A49.5,49.5,0,0,1,50,99.5Z",
    fill: "#ce1919"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-video",
    "data-name": "Icon awesome-video",
    d: "M54.32,32.77H28.43a4.29,4.29,0,0,0-4.29,4.29h0V62.94a4.29,4.29,0,0,0,4.29,4.29H54.32a4.29,4.29,0,0,0,4.29-4.29h0V37.06a4.29,4.29,0,0,0-4.29-4.29Zm17,3.38-9.85,6.79V57.07l9.85,6.77a2.88,2.88,0,0,0,4-.71,2.85,2.85,0,0,0,.52-1.6V38.47a2.89,2.89,0,0,0-4.53-2.32Z",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoDisabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video-disabled.01e758ba.svg";
export { ForwardRef as ReactComponent };